<div class="protection-details-accordion-panel-header__comparison-icons-header">
  <h5
    class="protection-details-accordion-panel-header__comparison-icons-header-heading"
  >
    {{ 'PROTECTION_DETAILS_CURRENT_WARRANTY' | translate }}
  </h5>
  <h5
    class="protection-details-accordion-panel-header__comparison-icons-header-heading"
  >
    {{ 'PROTECTION_DETAILS_QUOTE_EXTRA_COVERAGE' | translate }}
  </h5>
</div>

<dgx-components-accordion [panels]="panels">
  <ng-template
    #accordionPanelHeaderTemplate
    let-expanded="expanded"
    let-panel="panel"
  >
    <span
      [ngClass]="{
        'protection-details-accordion-panel-header--subtext':
          panels[0] === panel
      }"
      class="protection-details-accordion-panel-header"
    >
      <dgx-components-icon
        [name]="'chevron-down'"
        [ngClass]="{
          'protection-details-accordion-panel--expanded': expanded
        }"
        [size]="!isDesktop ? 'sm' : 'lg'"
        class="protection-details-accordion-panel-header__icon"
      />

      <p class="protection-details-accordion-panel-header__title">
        {{ panel.title }}
      </p>

      <div
        [ngClass]="{
          'protection-details-accordion-panel-header__comparison-icons--subtext':
            panels[0] === panel
        }"
        class="protection-details-accordion-panel-header__comparison-icons"
      >
        <dgx-components-icon
          *ngIf="panels[0] !== panel; else includedInWarranty"
          [name]="'times-circle'"
          [size]="'lg'"
          class="protection-details-accordion-panel-header__times-circle-icon"
        />

        <dgx-components-icon
          [family]="'solid'"
          [name]="'circle-check'"
          [size]="'lg'"
          class="protection-details-accordion-panel-header__circle-check-icon"
        />
      </div>
    </span>
  </ng-template>
  <ng-template
    #accordionPanelContentTemplate
    let-expanded="expanded"
    let-panel="panel"
  >
    <div class="protection-details-accordion-panel-body">
      <dgx-components-rich-text [content]="panel.body" />
    </div>
  </ng-template>

  <ng-template #includedInWarranty>
    <div class="protection-details-included-in-warranty">
      <dgx-components-icon
        [family]="'solid'"
        [name]="'circle-check'"
        [size]="'lg'"
        class="protection-details-accordion-panel-header__circle-check-icon"
      />
      <p
        *ngIf="warrantyLength"
        class="mt-2 typog-body protection-details-accordion-included-in-warranty-label"
      >
        {{ warrantyLength }} year {{ warrantyLength > 1 ? 's' : '' }} only
      </p>
    </div>
  </ng-template>
</dgx-components-accordion>
